export default {
      id: "logo-ru-usage",
      viewBox: "0 0 138 23",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#logo-ru",
      toString: function () {
        return this.url;
      }
    }